import Color from 'color'
import styled from 'styled-components'
import { LabelSemiBoldSmall } from 'components/base-ui/FontsV2'
import type { ButtonStyledProps } from './BtnSmallV2'

export const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const IconLoadingWrapper = styled.div`
  display: none;
  position: absolute;

  svg {
    width: 100%;
    height: auto;
  }
`

export const StyledButton = styled.button<ButtonStyledProps>`
  border: none;
  appearance: none;
  outline: none;
  user-select: none;

  &:focus {
    outline: none;
  }

  .no-touch & {
    ${({ loading }) =>
      loading &&
      `
      cursor: default;
    `}
  }

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
  padding-right: 8px;
  transition: 0.3s;
  background-color: transparent;

  &:active {
    transition: 0s;
  }

  min-width: 54px;
  height: 26px;

  border-radius: ${({ shape }) => (shape === 'rounded' ? '100px' : '4px')};

  ${ButtonContent} {
    column-gap: 4px;
  }
  ${IconLoadingWrapper} {
    width: 20px;
    height: 20px;
  }

  ${({ theme, fill, color, loading }) => {
    let btnColor = theme.colors.primary
    let btnColorActiveFilled = Color(btnColor).lighten(0.12).hex()
    let btnColorActiveOutlined = Color(btnColor).lighten(0.88).hex()

    if (color === 'monochrome') {
      btnColor = theme.colors.textAndBackgroundGrey
      btnColorActiveFilled = theme.colors.textAndBackgroundWhiteGrey
      btnColorActiveOutlined = theme.colors.textAndBackgroundWhiteGrey
    }

    switch (fill) {
      case 'filled':
        return `
          color: ${theme.colors.white};
          background-color: ${loading ? btnColorActiveFilled : btnColor};
          &:active {
            background-color: ${btnColorActiveFilled};
          }

          ${ButtonText} {
            color: ${theme.colors.white};
          }
        `
      case `outlined`:
        return `
          color: ${btnColor};
          box-shadow: 0 0 0 1px ${btnColor};

          ${
            !loading
              ? `
              &:active {
                background-color: ${btnColorActiveOutlined};
              }
            `
              : `
              background-color: ${btnColorActiveOutlined};
            `
          }

          ${ButtonText} {
            color: ${btnColor};
          }

          ${IconLoadingWrapper} circle {
            stroke: ${btnColor};
          }
        `
    }
  }}

  ${({ loading }) =>
    loading &&
    `
    ${IconLoadingWrapper} {
      display: block;
    }

    ${ButtonContent} {
      opacity: 0;
    }
  `}
`

export const ButtonText = styled(LabelSemiBoldSmall)`
  text-align: center;
`
